import React, { FC } from 'react';
import type { Props as TextInputProps } from '../TextInput/TextInput';
import TextInput from '../TextInput/TextInput';

export type Props = TextInputProps;

const LastNameInput: FC<Props> = (props) => {
  const {
    label = 'Last name (surname)',
    autoComplete = 'family-name',
    ...rest
  } = props;
  return <TextInput label={label} autoComplete={autoComplete} {...rest} />;
};

export default LastNameInput;
